import TabBarLayout from "@/layout/tabbar.vue";
// import Layout from "@/layout/default.vue";

import Login from "@/views/login"; // 登录
const Binding = () => import("@/views/login/binding"); // 绑定手机号
const Forgot = () => import("@/views/login/forgot"); // 找回密码
const Reset = () => import("@/views/login/forgot/reset"); // 找回密码-重置密码
const Home = () => import("@/views/home"); // 首页
const ThemeList = () => import("@/views/home/themelist"); // 首页
const Category = () => import("@/views/category"); // 分类
const FirstProduct = () => import("@/views/category/firstproduct"); // 一级商品分类
const Brand = () => import("@/views/category/brand"); // 一级商品分类

const Agreement = () => import("@/views/agreement"); // 协议

// const Global = () => import("@/views/global"); // 全球看
const Cart = () => import("@/views/cart"); // 购物车
// 我的
const Mine = () => import("@/views/mine"); // 我的
const PersonalCenter = () => import("@/views/mine/personalcenter"); // 我的个人中心
const PersonalMessage = () => import("@/views/mine/personalmessage"); // 我的个人信息
const CertificationList = () => import("@/views/mine/certificationlist"); // 我的实名认证列表
const AddCertification = () => import("@/views/mine/addcertification"); // 我的添加实名认证
const ModifyNickname = () => import("@/views/mine/modifynickname"); // 我的修改昵称
const ModifySign = () => import("@/views/mine/modifysign"); // 我的修改个性签名
const SecurityCheck = () => import("@/views/mine/securitycheck"); // 我的修改手机号安全检测
const ModifyPhone = () => import("@/views/mine/modifyphone"); // 我的修改手机号
const ModifyPassword = () => import("@/views/mine/modifypassword"); // 我的修改密码
const ModifyLoginPass = () => import("@/views/mine/modifyloginpass"); // 我的修改登录密码
const CardVoucher = () => import("@/views/mine/cardvoucher"); // 我的卡券列表
const CardPackageList = () => import("@/views/mine/cardpackagelist"); // 我的卡包列表
const UseList = () => import("@/views/mine/uselist"); // 我的卡券使用记录
const CardDetail = () => import("@/views/mine/carddetail"); // 我的卡券使用详情
const CardNote = () => import("@/views/mine/cardnote"); // 我的卡券使用详情添加备注
const QuestionList = () => import("@/views/mine/question/list"); // 我的客户服务列表
const QuestionDetail = () => import("@/views/mine/question/detail"); // 我的客户服务详情
const AddressList = () => import("@/views/mine/addresslist"); // 收货地址列表
const AddEditAddress = () => import("@/views/mine/addeditaddress"); // 新增、编辑收货人
const ReceiveCard = () => import("@/views/mine/receivecard"); // 新增、编辑收货人
const Coupon = () => import("@/views/mine/coupon"); // 优惠券

const ProductDetail = () => import("@/views/product/detail"); // 商品详情
const ProductShare = () => import("@/views/product/share"); // 商品规格分享页

const Search = () => import("@/views/search"); // 搜索

// const ProductDetail = () => import("@/views/product/detail"); // 商品搜索

const OrderList = () => import("@/views/order/list"); // 订单列表
const SearchOrder = () => import("@/views/order/searchorder"); // 搜索订单列表
const OrderDetail = () => import("@/views/order/detail"); // 订单详情
const Logistics = () => import("@/views/order/detail/logistics"); // 订单详情
const Purchase = () => import("@/views/order/purchase"); // 订单详情
const OrderDetailRefundReasion = () =>
  import("@/views/order/refund/orderdetailrefundreasion"); // 订单详情待发货售后
const ExchangeMilkOrder = () => import("@/views/order/exchangemilkorder"); // 确认订单兑换鲜奶
const ExchangeSuccess = () => import("@/views/order/exchangesuccess"); // 兑换鲜奶成功
const OrderPay = () => import("@/views/order/orderpay"); // 收银台
const OrderResult = () => import("@/views/order/orderresult"); // 支付结果
const ChooseDate = () => import("@/views/order/choosedate"); // 日期选择
const ExplainTime = () => import("@/views/order/explaintime"); // 发货说明
const MilkExplainTime = () => import("@/views/order/milkexplaintime"); // 鲜奶周期

const RefundList = () => import("@/views/order/refund/refundlist"); // 售后列表
const RefundDetail = () => import("@/views/order/refund/refunddetail"); // 售后列表
const ApplyPackage = () => import("@/views/order/refund/applypackage"); // 申请售后
const ChooseRefundType = () => import("@/views/order/refund/chooserefundtype"); // 选择售后类型
const ApplyRefund = () => import("@/views/order/refund/applyrefund"); // 填写售后信息
const AddProduct = () => import("@/views/order/refund/addproduct"); // 填写售后添加商品
const MilkPlan = () => import("@/views/order/milkplan"); // 鲜奶配送计划
const RefundHistory = () => import("@/views/order/refund/refundhistory"); // 售后协商历史
const AddLogistics = () => import("@/views/order/refund/addlogistics"); // 售后协商历史

const Order1 = () => import("@/views/agreement/order1"); // 预下单协议
const Login1 = () => import("@/views/agreement/login1"); // 预下单协议
const Login2 = () => import("@/views/agreement/login2"); // 预下单协议

const BannerLink = () => import("@/views/bannerlink");

const PosterSM = () => import("@/views/poster/sm");
const PosterADMachine = () => import("@/views/poster/ad-machine");
const Review = () => import("@/views/order/review");
const BuyerReviews = () => import("@/views/product/buyerReviews");
const Customer = () => import("@/views/customer");
const ValetPay = () => import("@/views/order/valetpay");
const MaterialDetail = () => import("@/views/material/detail/index.vue");

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/binding",
    name: "Binding",
    component: Binding
  },
  {
    path: "/forgot",
    name: "Forgot.Password",
    component: Forgot
  },
  {
    path: "/forgot/reset",
    name: "Forgot.Password.Reset",
    component: Reset
  },
  {
    path: "/",
    component: TabBarLayout,
    redirect: "/home",
    meta: {
      tabbar: true,
      keepAlive: true
    },
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
          title: "首页",
          keepAlive: true,
          normal: require("@/assets/tabbar/home.png"),
          active: require("@/assets/tabbar/home_s.png")
        }
      },
      {
        path: "/category",
        name: "Category",
        component: Category,
        meta: {
          title: "分类",
          normal: require("@/assets/tabbar/category.png"),
          active: require("@/assets/tabbar/category_s.png")
        }
      },
      // {
      //   path: "/global",
      //   name: "Global",
      //   component: Global,
      //   meta: {
      //     title: "全球看",
      //     normal: require("@/assets/tabbar/global.png"),
      //     active: require("@/assets/tabbar/home_s.png")
      //   }
      // },
      {
        path: "/cart",
        name: "Cart",
        component: Cart,
        meta: {
          title: "购物车",
          normal: require("@/assets/tabbar/cart.png"),
          active: require("@/assets/tabbar/cart_s.png")
        }
      },
      {
        path: "/mine",
        name: "Mine",
        component: Mine,
        meta: {
          title: "我的",
          normal: require("@/assets/tabbar/mine.png"),
          active: require("@/assets/tabbar/mine_s.png")
        }
      }
    ]
  },
  // 一级分类页
  {
    path: "/home/themelist",
    name: "ThemeList",
    component: ThemeList
  },
  // 一级分类页
  {
    path: "/category/firstproduct",
    name: "FirstProduct",
    component: FirstProduct
  },
  // 品牌馆
  {
    path: "/category/brand",
    name: "Brand",
    component: Brand
  },
  // 个人中心
  {
    path: "/mine/personalcenter",
    name: "PersonalCenter",
    component: PersonalCenter
  },
  // 个人信息
  {
    path: "/mine/personalmessage",
    name: "PersonalMessage",
    component: PersonalMessage
  },
  // 实名认证列表
  {
    path: "/mine/certificationlist",
    name: "CertificationList",
    component: CertificationList
  },
  // 添加实名认证
  {
    path: "/mine/addcertification",
    name: "AddCertification",
    component: AddCertification
  },
  // 修改昵称
  {
    path: "/mine/modifynickname",
    name: "ModifyNickname",
    component: ModifyNickname
  },
  // 修改个性签名
  {
    path: "/mine/modifysign",
    name: "ModifySign",
    component: ModifySign
  },
  // 修改手机号安全检测
  {
    path: "/mine/securitycheck",
    name: "SecurityCheck",
    component: SecurityCheck
  },
  // 修改手机号
  {
    path: "/mine/modifyphone",
    name: "ModifyPhone",
    component: ModifyPhone
  },
  // 修改密码
  {
    path: "/mine/modifypassword",
    name: "ModifyPassword",
    component: ModifyPassword
  },
  // 修改登录密码
  {
    path: "/mine/modifyloginpass",
    name: "ModifyLoginPass",
    component: ModifyLoginPass
  },
  //卡包列表
  {
    path: "/mine/cardvoucher",
    name: "CardVoucher",
    component: CardVoucher
  },
  //卡券列表
  {
    path: "/mine/cardpackagelist",
    name: "CardPackageList",
    component: CardPackageList
  },
  //卡券列表
  {
    path: "/mine/uselist",
    name: "UseList",
    component: UseList
  },
  // 卡券使用详情
  {
    path: "/mine/carddetail",
    name: "CardDetail",
    component: CardDetail
  },
  // 卡券使用详情添加备注
  {
    path: "/mine/cardnote",
    name: "CardNote",
    component: CardNote
  },
  // 领取鲜奶卡
  {
    path: "/mine/receivecard",
    name: "ReceiveCard",
    component: ReceiveCard
  },
  // 我的服务列表
  {
    path: "/mine/question/list",
    name: "QuestionList",
    component: QuestionList
  },
  // 我的服务问题详情
  {
    path: "/mine/question/detail",
    name: "QuestionDetail",
    component: QuestionDetail
  },
  // 收货地址列表
  {
    path: "/mine/addresslist",
    name: "AddressList",
    component: AddressList
  },
  // 收货地址列表
  {
    path: "/mine/addeditaddress",
    name: "AddEditAddress",
    component: AddEditAddress
  },
  {
    path: "/mine/coupon",
    name: "Coupon",
    component: Coupon
  },
  // 搜索
  {
    path: "/search",
    name: "Search",
    component: Search
  },
  // 商品详情
  {
    path: "/product/detail",
    name: "ProductDetail",
    component: ProductDetail
  },
  // 商品规格分享页
  {
    path: "/product/share",
    name: "ProductShare",
    component: ProductShare
  },

  // 订单列表
  {
    path: "/order/list",
    name: "OrderList",
    component: OrderList
  },
  // 订单搜索
  {
    path: "/order/searchorder",
    name: "SearchOrder",
    component: SearchOrder
  },
  //订单详情
  {
    path: "/order/detail",
    name: "OrderDetail",
    component: OrderDetail
  },
  //订单详情待发货售后
  {
    path: "/order/refund/orderdetailrefundreasion",
    name: "OrderDetailRefundReasion",
    component: OrderDetailRefundReasion
  },
  //订单详情查看物流
  {
    path: "/order/detail/logistics",
    name: "Logistics",
    component: Logistics
  },
  //确认订单兑换鲜奶
  {
    path: "/order/exchangemilkorder",
    name: "ExchangeMilkOrder",
    component: ExchangeMilkOrder
  },
  //确认订单
  {
    path: "/order/purchase",
    name: "Purchase",
    component: Purchase
  },
  //订单支付收银台
  {
    path: "/order/orderpay",
    name: "OrderPay",
    component: OrderPay
  },
  //订单支付结果
  {
    path: "/order/orderresult",
    name: "OrderResult",
    component: OrderResult
  },
  //日期选择
  {
    path: "/order/choosedate",
    name: "ChooseDate",
    component: ChooseDate
  },
  //发货说明
  {
    path: "/order/explaintime",
    name: "ExplainTime",
    component: ExplainTime
  },
  //鲜奶周期购说明
  {
    path: "/order/milkexplaintime",
    name: "MilkExplainTime",
    component: MilkExplainTime
  },
  //兑换鲜奶成功
  {
    path: "/order/exchangesuccess",
    name: "ExchangeSuccess",
    component: ExchangeSuccess
  },

  //售后列表
  {
    path: "/order/refund/refundlist",
    name: "RefundList",
    component: RefundList
  },
  //售后详情
  {
    path: "/order/refund/refunddetail",
    name: "RefundDetail",
    component: RefundDetail
  },
  //申请
  {
    path: "/order/refund/applypackage",
    name: "ApplyPackage",
    component: ApplyPackage
  },
  //申请
  {
    path: "/order/refund/chooserefundtype",
    name: "ChooseRefundType",
    component: ChooseRefundType
  },
  //申请
  {
    path: "/order/refund/applyrefund",
    name: "ApplyRefund",
    component: ApplyRefund
  },
  //填写售后添加商品
  {
    path: "/order/refund/addproduct",
    name: "AddProduct",
    component: AddProduct
  },
  //售后协商历史
  {
    path: "/order/refund/refundhistory",
    name: "RefundHistory",
    component: RefundHistory
  },
  //填写物流
  {
    path: "/order/refund/addlogistics",
    name: "AddLogistics",
    component: AddLogistics
  },
  //填写售后添加商品
  {
    path: "/order/milkplan",
    name: "MilkPlan",
    component: MilkPlan
  },
  //预下单协议
  {
    path: "/agreement/order1",
    name: "Order1",
    component: Order1
  },
  //用户协议
  {
    path: "/agreement/login1",
    name: "Login1",
    component: Login1
  },
  //隐私协议
  {
    path: "/agreement/login2",
    name: "Login2",
    component: Login2
  },
  {
    path: "/banner/link",
    name: "Banner.Link",
    component: BannerLink
  },
  // 海报h5
  {
    path: "/poster/sm",
    name: "Poster.SM",
    component: PosterSM
  },
  // 店主实体店广告机 投放海报
  {
    path: "/poster/ad-machine",
    name: "Poster.AD-Machine",
    component: PosterADMachine
  },
  // 评价
  {
    path: "/order/review",
    name: "Review",
    component: Review
  },
  // 全部评价
  {
    path: "/product/buyerReviews",
    name: "BuyerReviews",
    component: BuyerReviews
  },
  // 客服
  {
    path: "/customer",
    name: "Customer",
    component: Customer
  },
  // 协议
  {
    path: "/agreement",
    name: "Agreement",
    component: Agreement
  },
  {
    path: "/user/order/fast/qqgpay",
    name: "QQGPay",
    component: ValetPay
  },
  {
    path: "/material/detail",
    name: "Material.Detail",
    component: MaterialDetail,
    meta: {
      title: "素材详情"
    }
  }
];

export default routes;
